import { camelToSnake, cleanObj } from '~/utils/object';
import { post, put, URLs } from './request';

export const postSignup = async ({
  email,
  firstName,
  lastName,
  password,
  phoneNumber,
  provider,
  providerUid,
  providerToken,
}) => {
  const requestObj = camelToSnake(
    cleanObj({
      email,
      firstName,
      lastName,
      provider,
      providerUid,
      providerToken,
      phoneNumber,
      password,
    })
  );
  const { data } = await post({
    url: `${URLs.user}/sign-up`,
    data: requestObj,
  });
  return data;
};

export const postResetPassword = async ({ email }) => {
  const {
    data: { message },
  } = await post({
    url: `${URLs.api}/password/reset`,
    data: { email },
  });
  return message;
};

export const postVerifyCode = async ({ email, code }) => {
  const data = await post({
    url: `${URLs.api}/password/verify`,
    data: {
      email,
      code,
    },
  });
  return data;
};

export const putPassword = async ({ email, password, verificationCode }) => {
  const data = await put({
    url: `${URLs.api}/password`,
    data: {
      email,
      password,
      code: verificationCode,
    },
  });
  return data;
};
